import { render } from "./BFaceAvailablePeriodDisp.vue?vue&type=template&id=2e81c8c2&scoped=true"
import script from "./BFaceAvailablePeriodDisp.vue?vue&type=script&lang=js"
export * from "./BFaceAvailablePeriodDisp.vue?vue&type=script&lang=js"

import "./BFaceAvailablePeriodDisp.vue?vue&type=style&index=0&id=2e81c8c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2e81c8c2"

export default script